class BESSAppProjectFloorplanItem extends BESSAppBase {

    constructor(parent, root) {
        super();
        this.root = root;
        this.parent = parent;
        this.initialising = true;
        this.floorplanId = this.root.attr('data-floorplan-id');
        this.shownOnFloorPlansInput = this.root.find('.app-shown-on-floor-plans');
        this.shownOnFloorPlansNAInput = this.root.find('.app-shown-on-floor-plans-na');
        this.commentContainer = this.root.find('.app-comments-container');
        this.commentInput = this.commentContainer.find('textarea');
        initMaterialTextControl(this.commentInput, this.#updateState.bind(this));
        this.shownOnFloorPlansInput.change(this.#shownOnFloorPlansInputChange.bind(this));
        this.saving = false;
        this.saveRequired = false;
        this.initialising = false;
    }

    #shownOnFloorPlansInputChange(e) {
        let checkbox = $(e.target);
        this.shownOnFloorPlansInput.not(checkbox).setCheckedIf(false);
        this.#updateState();
    }

    #updateState() {
        this.commentContainer.showAnimatedIf(this.shownOnFloorPlansInput.isChecked());
        let completed = this.shownOnFloorPlansInput.isChecked();
        this.root.addClassIf('with-comment', completed && this.commentInput.val().length > 0);
        this.root.find('.tag-incomplete').hideIf(completed);
        this.root.find('.tag-complete').showIf(completed);
        this.saveRequired = true;
        if (!this.initialising) {
            this.doDelayed(this.#saveState.bind(this), 500);
        }
    }

    #saveState() {
        if (!this.saveRequired) return;
        if (this.saving) {
            this.doDelayed(this.#saveState.bind(this), 500);
            return;
        }
        this.saving = true;
        let completed = this.shownOnFloorPlansInput.isChecked();
        let isNotApplicable = this.shownOnFloorPlansNAInput.isChecked();
        let comment = this.commentInput.val().trim();
        this.saveRequired = false;
        this.parent.api().updateFloorplanItem(
            this.floorplanId, completed, isNotApplicable, comment, this.#onSaved.bind(this));
    }

    #onSaved(result) {
        this.saving = false;
        if (result.changed) {
            this.parent.updateState(result.state);
        }
    }
}